module.exports = __webpack_public_path__ + "img/question-circle.75783c79.svg";